import { render, staticRenderFns } from "./ReservationOTPDialog.vue?vue&type=template&id=e1c4b550&lang=pug&"
import script from "./ReservationOTPDialog.vue?vue&type=script&lang=ts&"
export * from "./ReservationOTPDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ReservationOTPDialog.vue?vue&type=style&index=0&id=e1c4b550&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports